import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { AnnouncementBar } from "@/components/site/AnnouncementBar";
import { Footer } from "@/components/site/Footer";
import { MobileBottomNav } from "@/components/site/MobileBottomNav";
import { ApplyModal } from "@/components/site/ApplyModal";
import { ApplyProvider } from "@/context/ApplyContext";
import { useLenis } from "@/hooks/useSite";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function SiteLayout() {
  useLenis();
  return (
    <ApplyProvider>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col">
        <AnnouncementBar />
        <Header />
        <main className="flex-1 pb-16 lg:pb-0">
          <Outlet />
        </main>
        <Footer />
        <MobileBottomNav />
      </div>
      <ApplyModal />
    </ApplyProvider>
  );
}
